import {Component} from '@angular/core';
import {RouteTranslations} from '../../../models/abstract/routeTranslations';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-account-setup-support-article',
    template: `
        <ng-container i18n="@@support.articles.accountSetup">
            <p>The trial version of the course is freely available without logging in. To use the full version you need an account. Your account ensures that your results, progress and typing diploma are securely stored.</p>
            <h2>Through your school or company</h2>
            <p>Do you use Tyyp through your school or company? Then there are two ways to receive your login details:</p>
            <ol>
                <li>
                    <span>Either the administrator of your school/company creates your account and provides you the login details.</span>
                </li>
                <li>
                    <span>Or the administrator of your school/company sends you a link with which you can register yourself.</span>
                </li>
            </ol>
            <h2>Purchased in the webshop</h2>
            <p>Did you order the course in <a routerLink="/{{ RouteTranslations.purchase[languageService.getActiveLanguageCode()] }}">the webshop</a>? Then you will receive an email immediately after purchase with instructions to create your account.</p>
            <p>You can get started with the course right away.</p>
        </ng-container>
    `
})
export class AccountSetupSupportArticleComponent {
    protected readonly RouteTranslations = RouteTranslations;

    constructor(
        public languageService: LanguageService
    ) {}
}
